module.exports = __webpack_public_path__ + "src/assets/tabular_view_off.png";